import type { ReactNode } from 'react';

import { useMemo, useState, useCallback } from 'react';

import { SupportDrawerContext } from './support-drawer-context';

// ----------------------------------------------------------------------

export function SupportDrawerProvider({ children }: { children: ReactNode }) {
  const [ticket, setTicket] = useState('');
  const [drawerWidth, setDrawerWidth] = useState('360px');
  const [openDrawer, setOpenDrawer] = useState(false);

  const changeTicket = useCallback((ticketId: string) => {
    setTicket(ticketId);
    setOpenDrawer(true);
  }, []);

  const setWidth = useCallback((newDrawerWidth: string) => {
    setDrawerWidth(newDrawerWidth);
  }, []);

  const onToggleDrawer = useCallback(() => {
    setOpenDrawer((prev) => !prev);
  }, []);

  const onCloseDrawer = useCallback(() => {
    setOpenDrawer(false);
  }, []);

  const memoizedValue = useMemo(
    () => ({
      supportTicketId: ticket,
      openDrawer,
      drawerWidth,
      changeTicket,
      setWidth,
      onCloseDrawer,
      onToggleDrawer,
    }),
    [ticket, openDrawer, drawerWidth, changeTicket, setWidth, onCloseDrawer, onToggleDrawer]
  );

  return (
    <SupportDrawerContext.Provider value={memoizedValue}>{children}</SupportDrawerContext.Provider>
  );
}
